import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Sparkles, ArrowRight } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { initializeGtag } from "@/utils/gtag";

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    initializeGtag();
    toast({
      title: "Ödeme Başarılı",
      description: "Kampüs Mentorluk ailesine hoş geldiniz!",
    });
  }, [toast]);

  return (
    // ARKA PLAN: Diğer sayfalarla uyumlu derin indigo geçişi
    <div className="min-h-screen bg-gradient-to-br from-[#4F46E5] via-[#3730A3] to-[#1E293B] flex items-center justify-center p-4">

      {/* KART: Glassmorphism (Cam Efekti) */}
      <Card className="w-full max-w-md bg-slate-900/60 border-white/10 backdrop-blur-xl shadow-2xl text-white relative overflow-hidden">

        {/* Dekoratif Işık Efekti (Arka planda hafif bir parıltı) */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-emerald-500/10 blur-[80px] rounded-full"></div>

        <CardHeader className="text-center pb-2 relative z-10">
          <div className="flex justify-center mb-6">
            <div className="relative">
              {/* Başarı İkonu arkasında Yeşil Parlama */}
              <div className="absolute inset-0 bg-emerald-500/20 blur-2xl rounded-full"></div>
              <CheckCircle2 className="w-20 h-20 text-emerald-400 relative z-10" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold text-white flex items-center justify-center gap-2">
            Harika Bir Başlangıç! <Sparkles className="w-6 h-6 text-yellow-400" />
          </CardTitle>
        </CardHeader>

        <CardContent className="text-center space-y-8 pt-4 relative z-10">
          <div className="space-y-4">
            <p className="text-slate-200 text-lg font-medium">
              Ödemeniz başarıyla tamamlandı. Mentörlük programına hoş geldiniz!
            </p>
            <div className="bg-emerald-500/10 border border-emerald-500/20 p-4 rounded-xl">
              <p className="text-emerald-300 text-sm leading-relaxed">
                🚀 <strong>Sıradaki Adım:</strong> Mentörünüz sizinle 24 saat içerisinde kayıtlı telefon numaranız üzerinden iletişime geçecektir.
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {/* ANA BUTON: Indigo renginde */}
            <Button
              onClick={() => navigate("/")}
              className="w-full bg-[#4F46E5] hover:bg-[#4338CA] text-white h-14 text-lg font-bold shadow-lg shadow-indigo-500/20 transition-all flex items-center justify-center gap-2 group"
            >
              Ana Sayfaya Dön
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>

            <p className="text-xs text-slate-500 uppercase tracking-widest pt-4">
              İşlem ID: #KMP-{Math.floor(Math.random() * 90000) + 10000}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;